import EvaluationView from '@/views/evaluation/evaluation-view'
import EvaluationViewer from '@/views/evaluation/evaluation-viewer.view'
import store from '@/store'

export default [
  {
    path: '/evaluation/:id',
    name: 'evaluation',
    component: EvaluationView,
    props: false
  },
  {
    path: '/evaluation/viewer/:id',
    name: 'evaluation-viewer',
    component: EvaluationViewer,
    beforeEnter (to, from, next) {
      store.dispatch('evaluations/get', {
        ...to.params,
        with: 'branch, layout, period'
      })
        .then(response => {
          return store.dispatch('dealers/get', {
            id: response.data.branch.dealerId
          }).then(next)
        })
        .catch(next)
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/evaluation/index.js